import { useEffect } from "react";
import { toast } from "sonner";

let lenisRef = null;
export const setLenis = (l) => { lenisRef = l; window.__lenis = l; };
export const getLenis = () => lenisRef;

export const scrollToContact = () => {
  const el = document.getElementById("contact");
  if (!el) return;
  if (lenisRef) lenisRef.scrollTo(el, { offset: -40, duration: 1.6 });
  else el.scrollIntoView({ behavior: "smooth" });
};

export const comingSoon = (label) =>
  toast(`${label} is coming soon`, {
    description: "This page is being written. In the meantime, speak to a search specialist.",
  });

export const useSeo = (title, description, raw = false) => {
  useEffect(() => {
    document.documentElement.dataset.seoRaw = raw ? "1" : "";
    document.title = title;
    const m = document.querySelector('meta[name="description"]');
    if (m) m.setAttribute("content", description);
  }, [title, description, raw]);
};

export const EASE = [0.16, 1, 0.3, 1];
